<template>
  <div class="tip1_module_one trans" :style="bigBox">
    <div class="fill_title1 pos1">
      <div>药师签名</div>
      <div class="close_x pointer" @click="noeModule">
        <img src="../img/x.png" class="x-size" />
      </div>
    </div>
    <div :style="bigBox" class="hiddenInfo">
      <div class="singth-box">
        <div v-if="!OrderInfo.OpenAuditStatus">
          <div class="flex-3 fiex-center bd-and-mg" v-show="signaNum == 3">
            <div class="flex-3">
              <div class="first">审核药师：</div>
              <div class="two">
                <img
                  v-if="PharAuditNameUrl && PharAuditNameUrl.length > 0"
                  :src="PharAuditNameUrl"
                  alt
                />
              </div>
            </div>
            <div class="view_pre_double_btn">
              <div class="pointer" v-if="PharAuditNameUrl" @click="out(1)">
                撤销
              </div>
              <div class="pointer" v-if="!PharAuditNameUrl" @click="sign(1)">
                签名
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="flex-3 fiex-center bd-and-mg"
          style="text-align: center;"
        >
          <div class="open_desc">{{ OrderInfo.OpenAuditDesc }}</div>
        </div>
        <div class="flex-3 fiex-center bd-and-mg">
          <div class="flex-3">
            <div class="first">调配药师/士：</div>
            <div class="two">
              <img
                v-if="PharDispensingNameUrl && PharDispensingNameUrl.length > 0"
                :src="PharDispensingNameUrl"
                alt
              />
            </div>
          </div>

          <div class="view_pre_double_btn">
            <div class="pointer" v-if="PharDispensingNameUrl" @click="out(2)">
              撤销
            </div>
            <div class="pointer" v-if="!PharDispensingNameUrl" @click="sign(2)">
              签名
            </div>
          </div>
        </div>

        <div class="flex-3 fiex-center bd-and-mg">
          <div class="flex-3">
            <div class="first">复核/发药药师：</div>
            <div class="two">
              <img
                v-if="PharReviewNameUrl && PharReviewNameUrl.length > 0"
                :src="PharReviewNameUrl"
                alt
              />
            </div>
          </div>

          <div class="view_pre_double_btn">
            <div class="pointer" v-if="PharReviewNameUrl" @click="out(3)">
              撤销
            </div>
            <div class="pointer" v-if="!PharReviewNameUrl" @click="sign(3)">
              签名
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="view_pre_double_btn flex2"
      style="position:fixed;bottom:0;background:#FFFFFF;width:100%;padding:10px;"
    >
      <div class="pointer" @click="noeModule">取消</div>
      <div class="pointer" @click="save">保存</div>
    </div>
  </div>
</template>
<script>
import {
  GetPharName,
  SignPharmacistName,
  GetQRCodePharName,
  AuditPrescribe,
} from "@/utils/api.js";
import { getToken } from "@/utils/common.js";
import { mapState } from "vuex";
export default {
  props: {
    InquiryId: {
      default: false,
    },
    PrescriptionStatus: {
      default: false,
    },
    signaNum: {
      default: false,
    },
  },
  computed: {
    ...mapState({
      signUrl: (state) => state.autograph.signUrl,
    }),
  },
  data() {
    return {
      OrderInfo: {},
      PharAuditNameUrl:
        sessionStorage.getItem("PharAuditNameUrl") == "null"
          ? null
          : sessionStorage.getItem("PharAuditNameUrl"),
      PharDispensingNameUrl:
        sessionStorage.getItem("PharDispensingNameUrl") == "null"
          ? null
          : sessionStorage.getItem("PharDispensingNameUrl"),
      PharReviewNameUrl:
        sessionStorage.getItem("PharReviewNameUrl") == "null"
          ? null
          : sessionStorage.getItem("PharReviewNameUrl"),
      imgUrl: [],
      timer: null,
      QRurlDeployment: "", //调配
      QRurlReview: "", //复核
      QRurlExamine: "", //审核
      swidth: 550,
      sHeight: 750,
      bigBox: {},
      AuditType: 0,
      DispensingType: 0,
      ReviewType: 0,
    };
  },
  methods: {
    //签名
    sign(type) {
      //1==审核药师签名 2==调配药师签名 3==复核药师签名
      if (type == 1) {
        if (this.AuditType == 0) {
          this.AuditType = 1;
        } else if (this.AuditType == 3) {
          this.AuditType = 2;
        }
        this.PharAuditNameUrl = this.signUrl;
      } else if (type == 2) {
        if (this.signaNum == 3 && !this.PharAuditNameUrl &&!this.OrderInfo.OpenAuditStatus) {
          this.$Message.error("请先签名，审核药师");
        } else {
          //再零的情况下点击签名改为1
          if (this.DispensingType == 0) {
            this.DispensingType = 1;
          } else if (this.DispensingType == 3) {
            this.DispensingType = 2;
          }
          this.PharDispensingNameUrl = this.signUrl;
        }
      } else if (type == 3) {
        if (this.signaNum == 3 && !this.PharAuditNameUrl &&!this.OrderInfo.OpenAuditStatus) {
          this.$Message.error("请先签名，审核药师");
        } else {
          if (this.ReviewType == 0) {
            this.ReviewType = 1;
          } else if (this.ReviewType == 3) {
            this.ReviewType = 2;
          }
          this.PharReviewNameUrl = this.signUrl;
        }
      }
    },

    //撤销
    out(type) {
      //1==审核药师签名 2==调配药师签名 3==复核药师签名
      if (type == 1) {
        this.AuditType = 3;
        this.PharAuditNameUrl = null;
      } else if (type == 2) {
        this.DispensingType = 3;
        this.PharDispensingNameUrl = null;
      } else if (type == 3) {
        this.ReviewType = 3;
        this.PharReviewNameUrl = null;
      }
    },
    noeModule() {
      this.$emit("noeModules");
    },
    //获取签名二维码
    GetCode() {
      const msg = this.$Message.loading({
        content: "请稍候",
        duration: 0,
      });
      GetQRCodePharName({
        Token: localStorage.getItem("hToken"),
        AppKey: this.$store.state.AppKey,
        userId: localStorage.getItem("app_mobile"),
      }).then((res) => {
        if (res == "Again") {
          this.GetCode();
          return;
        }
        setTimeout(msg, 17);
        if (res.errcode == 0) {
          this.QRurlDeployment = res.DispensingUrl; //调配药师签名
          this.QRurlReview = res.ReviewUrl; //复核药师签
          this.QRurlExamine = res.AuditUrl; //审核药师签名图片
        }
      });
    },
    //获取药师的签名的记录
    getImgurl() {
      GetPharName({
        Token: localStorage.getItem("hToken"),
        AppKey: this.$store.state.AppKey,
        UserId: localStorage.getItem("app_mobile"),
      }).then((res) => {
        if (res == "Again") {
          this.getImgurl();
          return;
        }
        if (res.errcode == 0) {
          this.imgUrl = res;
        }
      });
    },
    //保存签名
    save() {
      var params = {
        LoInquiryId: this.InquiryId,
        AuditChannel: "1",
        AuditType: this.AuditType,
        DispensingType: this.DispensingType,
        ReviewType: this.ReviewType,
      };
      AuditPrescribe(params).then((res) => {
        if (res.code == 1) {
          this.$Message.success("保存成功！");
          let timeout = setInterval(() => {
            this.noeModule();
            setTimeout(timeout);
          }, 2000);
          return;
        } else {
          this.$Message.error(res.msg);
        }
        console.log(res);
      });
    },
  },
  mounted() {
    this.sWidth = document.body.clientWidth;
    this.sHeight = document.body.clientHeight;
    this.bigBox = {
      // width: this.sWidth * 0.4+"px",
      height: this.sHeight * 0.67 + "px",
    };
    this.OrderInfo = JSON.parse(sessionStorage.getItem("cuerOrderInfo"));
    console.error(this.OrderInfo, " this.OrderInfo");
    // this.PharAuditNameUrl = sessionStorage.getItem("PharAuditNameUrl");
    // this.PharDispensingNameUrl = sessionStorage.getItem(
    //   "PharDispensingNameUrl"
    // );

    // this.PharReviewNameUrl = sessionStorage.getItem("PharReviewNameUrl");
    // 相同参数：Type 1=调配药师签名图片;2=复核药师签名图片;3=审核药师签名图片;
    // this.GetCode();
    // this.getImgurl();
    // this.timer = setInterval(() => {
    //   this.getImgurl();
    // }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.tip1_module_one {
  position: absolute;
  background-color: #fff;
  text-align: center;
  width: 550px;
  overflow: hidden;
  .pointer {
    cursor: pointer;
  }
  .hiddenInfo {
    background-color: #fff;
    text-align: center;
    // width: 550px;
    padding-bottom: 120px;
    overflow-y: scroll;
  }
  .singth-box {
    margin-top: 15px;
    .flex-3 {
      display: flex;
      justify-content: space-between;
    }
    .color-blud {
      color: #3399ff;
    }
    .fiex-center {
      align-items: center;
    }
    .open_desc {
      flex: 1;
      padding: 30px 0;
    }
    .bd-and-mg {
      padding: 20px 0;
      border-bottom: 1px solid #f2f2f2;
    }
    .first {
      width: 130px;
    }
    .two {
      width: 220px;
      height: 120px;
      border: 1px solid #000;
      overflow: hidden;
      img {
        width: 200px;
        height: 100px;
        margin: 10px;
      }
    }
    .er-code {
      padding: 0 30px 0 13px;
      width: 200px;
      // border-left: 1px solid #f2f2f2;
      border-left: 1px solid red($color: #000000);

      .code {
        padding: 3px 0 10px 0;
        img {
          width: 100px;
          height: 100px;
        }
      }
    }
  }
  .tip-box {
    background: #ffffcc;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #000;
    font-weight: 400;
    span {
      color: #3399ff;
    }
  }
  .fill_title1 {
    height: 56px;
    background: rgba(47, 49, 139, 1);
    text-align: center;
    line-height: 56px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    // margin-bottom: 20px;
  }
  .close_x {
    font-size: 16px;
    position: absolute;
    right: 20px;
    font-weight: 500;
    top: 50%;
    transform: translateY(-50%);
  }
  .x-size {
    width: 12px;
    height: 12px;
  }
  .view_pre_double_btn {
    // margin: 10px 0;
    justify-content: center;
    div:first-child {
      width: 106px;
      height: 36px;
      border: 1px solid rgba(47, 49, 139, 1);
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      box-sizing: border-box;
      margin-right: 51px;
      color: rgba(47, 49, 139, 1);
    }
    div:last-child {
      width: 106px;
      height: 36px;
      background: rgba(47, 49, 139, 1);
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>
